// extracted by mini-css-extract-plugin
export default {"link":"WP-z","disabled":"XP-z"};